module.exports = __webpack_public_path__ + "gamecode/img/antslg_favicon.png?b089e3d2";